// src/services/patientAIAssistant.js
//
// AVIA calls (Patient Appointments Task 4). Authenticated only.
//
//   * free text goes to /chat; everything that could change an appointment is
//     an allowlisted action with an opaque `ref` the server issued;
//   * no patient id, service/slot/hold id, price or time is ever sent;
//   * conversations are listed from the server -- nothing is kept in
//     localStorage, and no hold token exists on this side at all.

import { api } from "../lib/patientApi";

const BASE = "/api/v1/patients/ai-assistant";

export const patientAIAssistantApi = {
  async send({ sessionId, message, timezone, browserTimezone }, { signal } = {}) {
    const res = await api.post(
      `${BASE}/chat`,
      {
        session_id: sessionId || undefined,
        message,
        timezone: timezone || undefined,
        browser_timezone: browserTimezone || undefined,
      },
      { signal, timeout: 45000 }
    );
    return res.data;
  },

  async act({ sessionId, action, ref, reason, replaceExisting = false, timezone, browserTimezone }, { signal } = {}) {
    const res = await api.post(
      `${BASE}/actions`,
      {
        session_id: sessionId,
        action,
        ref: ref || undefined,
        reason: reason || undefined,
        replace_existing: replaceExisting,
        timezone: timezone || undefined,
        browser_timezone: browserTimezone || undefined,
      },
      { signal, timeout: 45000 }
    );
    return res.data;
  },

  // Filter chips / Edit filters / "use my location": the same search state as
  // chat. `filters` uses the canonical discovery filter names; `clear` removes
  // named filters; coordinates are sent once and never stored.
  async filters({ sessionId, filters = {}, clear = [], reset = false, near, timezone, browserTimezone }, { signal } = {}) {
    const res = await api.post(
      `${BASE}/filters`,
      {
        session_id: sessionId || undefined,
        filters,
        clear,
        reset,
        near: near || undefined,
        timezone: timezone || undefined,
        browser_timezone: browserTimezone || undefined,
      },
      { signal, timeout: 45000 }
    );
    return res.data;
  },

  async sessions({ page = 1, limit = 30 } = {}, { signal } = {}) {
    const res = await api.get(`${BASE}/sessions`, { params: { page, limit }, signal });
    return res.data;
  },

  async session(sessionId, { signal } = {}) {
    const res = await api.get(`${BASE}/sessions/${sessionId}`, { signal });
    return res.data;
  },
};

export default patientAIAssistantApi;
